import { render, staticRenderFns } from "./WorkingStats.vue?vue&type=template&id=4b5e3fda&"
import script from "./WorkingStats.vue?vue&type=script&lang=js&"
export * from "./WorkingStats.vue?vue&type=script&lang=js&"
import style0 from "./WorkingStats.vue?vue&type=style&index=0&id=4b5e3fda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports